import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PulseFitStudio from "./components/PulseFitStudio";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PulseFitStudio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;